import { useEffect, useState } from 'react';
import { Menu, Table } from 'semantic-ui-react';
import { getAsync, postAsync, reactURL } from '../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../components/helper/downloadCSVHelper';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import ReactPaginate from 'react-paginate';
import LoadingAnimation from '../../../components/LoadingAnimation';


const ViewGiftLogs = () => {
  const { referralLink } = useParams();
  const [giftLogs, setGiftLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [buttonIsLoading, setButtonIsLoading] = useState(false);
  const [next, setNext] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  useEffect(() => {
    localStorage.setItem('isHome', true);
    (async () => {
      const response = await getAsync(`GiftService/GetGiftBeneficiaryByGiftLogLink/${referralLink}`);
      const newItem = response?.data;
      setGiftLogs(newItem);
      setIsLoading(false);
      setPageCount(response?.page);
      setNext(pageOptions.pageNo);
    })();
  }, []);

  // Generate Resend Link
  const handleResendLink = async (data) => {
    setButtonIsLoading(true);
    try {
      await postAsync(
        `EP_UserAuthentication/SendSmsToBeneficiary?SenderName=${data.senderName}&BeneficiaryName=${data.beneName}&CertificateLink=${reactURL}/Gift/${data.giftLinkID}&Mobile=${data.beneMobile}`,
      );
      toast.success(t('Successfully send'));
      setButtonIsLoading(false);
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
      console.log(error, 'errorerror');
      setButtonIsLoading(false);
    }
  };

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = giftLogs?.map((item, ii) => ({
      'S.No': ii + 1,
      'Sender Name': item.senderName,
      'Benificiary Name': item.beneName,
      'Benificiary Mobile': item.beneMobile,
    }));

    downloadCSV(filteredData, 'View Gift Logs');
  };

  const handlePrint = (e) => {
    e.preventDefault();

    // Agar koi data nahi to alert
    if (!giftLogs || giftLogs.length === 0) {
      alert('No Gift Logs data to print!');
      return;
    }

    // Temporary container banao (tumhare style jaisa)
    const tableContainer = document.createElement('div');
    tableContainer.className = 'tableData my-4';

    // Heading exactly tumhare style mein
    const heading = document.createElement('h1');
    heading.className = 'font-bold text-center mb-5 sm:text-2xl text-xl text-customgreen';
    heading.innerText = `${t('Gift Logs')}`;
    tableContainer.appendChild(heading);

    // Table banao
    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';

    table.innerHTML = `
    <thead style="background-color: #2f855a; color: white;">
      <tr>
        <th style="padding: 8px; border: 1px solid #ddd;">#</th>
        <th style="padding: 8px; border: 1px solid #ddd;">${t('Sender Name')}</th>
        <th style="padding: 8px; border: 1px solid #ddd;">${t('Benificiary Name')}</th>
        <th style="padding: 8px; border: 1px solid #ddd;">${t('Benificiary Mobile')}</th>
      </tr>
    </thead>
    <tbody>
      ${giftLogs
        .map((item, index) => {
          const sno = (next - 1) * pageOptions.pageSize + index + 1;

          // Tumhare data fields ke hisaab se safe access
          const senderName = item.senderName || item.sender_name || item.SenderName || '-';
          const beneName = item.beneName || item.beneficiary_name || item.bene_name || 'testing';
          const beneMobile = item.beneMobile || item.beneficiary_mobile || item.bene_mobile || '-';

          return `
            <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'};">
              <td style="padding: 8px; border: 1px solid #ddd;">${sno}</td>
              <td style="padding: 8px; border: 1px solid #ddd;">${senderName}</td>
              <td style="padding: 8px; border: 1px solid #ddd;">${beneName}</td>
              <td style="padding: 8px; border: 1px solid #ddd;">${beneMobile}</td>
            </tr>
          `;
        })
        .join('')}
    </tbody>
  `;

    tableContainer.appendChild(table);
    document.body.appendChild(tableContainer);

    // Tumhare bilkul same print CSS
    const style = document.createElement('style');
    style.textContent = `
    @media print {
      body * {
        visibility: hidden;
        height: 0;
      }
      .tableData, .tableData * {
        visibility: visible;
      }
      .tableData {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: auto;
        overflow: visible;
      }
      h1 {
        margin: 20px 0 !important;
      }
    }
  `;
    document.head.appendChild(style);

    // Print karo
    window.print();

    // Cleanup (print ke baad remove kar do)
    setTimeout(() => {
      if (document.body.contains(tableContainer)) {
        document.body.removeChild(tableContainer);
      }
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    }, 500);

    return 'success';
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync('GiftService/GetGiftBeneficiaryByGiftLogLink/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  return (
    <div className="container-fluid py-16  xl:pt-40">
      {/* new code  start */}
      <div className="row justify-center mb-5">
        <div className=" col-lg-11 ">
          <div className="card">
            <div className="card-header text-center">
              <h1 className="text-3xl text-customgreen  font-bold">{t('Gift Logs')}</h1>
            </div>
            <div className="card-body">
              <div className="row ">
                <div className="col-lg-12 flex justify-center md:justify-end gap-2">
                  <div className="flex justify-center md:flex-row md:justify-end">
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      onClick={handlePrint}
                    >
                      {<span>{t('Print')}</span>}
                    </button>
                  </div>
                  <div className="flex justify-center md:flex-row md:justify-end gap-2">
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      onClick={(e) => handleOnExport(e)}
                    >
                      {t('Export')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* new code end */}

      {/* <div className="col-lg-12"> */}
      {/* <div  className="form-group">
            <button
              className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
              onClick={handlePrint}

            >
              {<span>{t('Print')}</span>}
            </button>
          </div>
          <div  className="form-group">
            <button
              className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
              onClick={(e) => handleOnExport(e)}
            >
              {t('Export')}
            </button>
          </div> */}
      {/* </div> */}
      {isLoading ? (
        <div className="row justify-center">
          <div className="col-lg-12">
            <LoadingAnimation
              imageStyling={''}
              styling={'flex items-center py-5 align-middle justify-center space-x-2'}
            />
          </div>
        </div>
      ) : (
        <>
          {giftLogs.length ? (
            <>
              <div className="row justify-center">
                <div className="col-lg-11  ">
                  <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <Table className="text-sm  rounded-2xl rtl:text-right text-center ">
                      <Table.Header className="text-xs text-white rounded-2xl bg-customgreen uppercase ">
                        <Table.Row className="rounded-2xl  whitespace-nowrap">
                          <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Sender Name')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Benificiary Name')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Benificiary Mobile')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Resend Link')}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body className="align-middle text-center">
                        {giftLogs.map((item, index) => {
                          const sno = (next - 1) * pageOptions.pageSize + index + 1;
                          return (
                            <Table.Row key={index}>
                              <Table.Cell className="whitespace-nowrap">{sno}</Table.Cell>
                              <Table.Cell className="whitespace-nowrap">{item?.senderName}</Table.Cell>
                              <Table.Cell className="whitespace-nowrap">{item?.beneName}</Table.Cell>
                              <Table.Cell className="whitespace-nowrap text-center">{item?.beneMobile}</Table.Cell>

                              <Table.Cell className="whitespace-nowrap">
                                <button
                                  disabled={buttonIsLoading}
                                  onClick={() => handleResendLink(item)}
                                  className={`text-white bg-customgreen  hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center ${buttonIsLoading && 'cursor-not-allowed'}`}
                                >
                                  {t('Resend')}
                                </button>
                              </Table.Cell>
                            </Table.Row>
                          );
                        })}
                      </Table.Body>
                    </Table>
                  </div>
                  {pageCount > 0 && (
                    <>
                      <div className="flex  flex-row px-3 justify-between">
                        <Menu pagination>
                          <Menu.Item>
                            <ReactPaginate
                              previousLabel={t('Previous')}
                              nextLabel={t('Next')}
                              pageCount={pageCount}
                              onPageChange={changePage}
                              containerClassName={'paginationButtons'}
                              previousLinkClassName={'previousButton'}
                              nextLinkClassName={'nextButton'}
                              disabledClassName={'paginationDisabled'}
                              activeClassName={'paginationActive'}
                            />
                          </Menu.Item>
                        </Menu>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          ) : (
            <datanotfound />
          )}
        </>
      )}
    </div>
  );
};

export default ViewGiftLogs;
